import { BoardCommond, OPERATION_TYPE } from "@/types";
import { DrawToolType, enumOpType } from "@/types";

///////////////////////////////////////////////////////////////////////////////

const temp = {
  PointData:
    "(253,382);(253,382);(253,382);(253,382);(253,383);(253,383);(253,384);\
  (253,384);(256,388);(259,393); (264,398);(268,401);(276,406);(282,409);(294,416);\
  (316,426);(336,432);(353,436);(386,441);(419,442);(443,443);(465,443);(479,443);\
  (503,443);(533,443);(548,442);(564,441);(575,441);(583,441);(595,440);(602,440);\
  (605,440);(608,440)",
  attribute: {
    height: 61, //#选中绘制的外边框矩形的宽度
    outlineColor: "#0a0a0a", //#线的颜⾊
    outlineWidth: 5, //#线的宽度
    rotate: 0, //#选中绘制的外边框矩形的旋转⾓度
    width: 355, //#选中绘制的外边框矩形的⾼度
    xPt: 430.5, //#选中绘制的外边框矩形的左上⾓x位置

    yPt: 412.5, //#选中绘制的外边框矩形的左上⾓y位置
    zPt: 0,
  },
  name: "PathNode_1", // #当前绘制的名字
  type: 6, // #绘制项⽬类型，⽐如笔，荧光笔
  viewWidth: 100, //#当前绘制视⼝的宽度
  viewHeight: 100, //#当前绘制视⼝的⾼度
};
// line
const a0 = {
  id: "f5036c13-bdc0-44e1-ab83-a619cae6d229",
  timestamp: 1650149995478,
  op: "line",
  data: {
    tool: "line",
    color: "#f55b6c",
    size: 2,
    start: {
      x: 647,
      y: 163.40625,
    },
    end: {
      x: 915,
      y: 162.40625,
    },
    position: {
      x: 647,
      y: 163.40625,
      w: 268,
      h: -1,
      center: [781, 162.90625],
    },
  },
};
// path
const a1 = {
  id: "09f7e64e-11d6-4e11-970d-f66a64fe3c65",
  timestamp: 1649598873607,
  op: "line",
  data: {
    tool: "pencil",
    color: "#50e3c2",
    size: 5,
    points: [
      {
        x: 534,
        y: 285.40625,
      },
    ],
    position: {
      x: 534,
      y: 283.40625,
      w: 258,
      h: 98,
      center: [663, 332.40625],
    },
  },
};
// rect
const a2 = {
  id: "b24d6fb4-a806-4f18-9ba0-56f2df870cde",
  timestamp: 1649598883586,
  op: "shape",
  data: {
    tool: "rectangle",
    color: "#50e3c2",
    size: 1,
    fill: "",
    start: {
      x: 733,
      y: 82.40625,
    },
    end: {
      x: 864,
      y: 145.40625,
    },
    position: {
      x: 733,
      y: 82.40625,
      w: 131,
      h: 63,
      center: [798.5, 113.90625],
    },
  },
};

const a3 = {
  id: "803b67a1-f317-48b9-a73d-ae0c66035822",
  timestamp: 1649598889309,
  op: "text",
  data: {
    pos: [976, 319],
    text: "123123123",
    fontSize: 16,
    position: {
      x: 976,
      y: 319,
      w: 72,
      h: 16,
      center: [1012, 327],
    },
  },
};

const a4 = {
  id: "767ad74e-4f25-4c5f-b8d0-4449a129399e",
  timestamp: 1649599055049,
  op: "shape",
  data: {
    tool: "ellipse",
    color: "#50e3c2",
    size: 1,
    fill: "",
    start: {
      x: 451,
      y: 81.40625,
    },
    end: {
      x: 580,
      y: 151.40625,
    },
    position: {
      x: 451,
      y: 81.40625,
      w: 129,
      h: 70,
      center: [515.5, 116.40625],
    },
  },
};

////////////////////////////////////////////////////////////////////////////////

// web -> other : path
const webToOtherPath = (o: any, width: number, height: number) => {
  const ap = o.data.points.map(
    (x: any) => `(${Math.floor(x.x)},${Math.floor(x.y)})`
  );
  const data = {
    name: o.id,
    PointData: ap.join(";"),
    type: enumOpType.t_PathItem,
    viewWidth: Math.floor(width),
    viewHeight: Math.floor(height),
    attribute: {
      height: Math.floor(o.data.position.h),
      outlineColor: o.data.color,
      outlineWidth: Math.floor(o.data.size),
      rotate: 0, //#选中绘制的外边框矩形的旋转⾓度
      width: Math.floor(o.data.position.w),
      xPt: Math.floor(o.data.position.x),
      yPt: Math.floor(o.data.position.y),
      zPt: 0,
    },
  };
  return {
    cmdId: BoardCommond.BoardData,
    data: JSON.stringify(data),
  };
};
// web -> other : line
const webToOtherLine = (o: any, width: number, height: number) => {
  const apoints = `(${Math.floor(o.data.start.x)},${Math.floor(
    o.data.start.y
  )});(${Math.floor(o.data.end.x)},${Math.floor(o.data.end.y)})`;
  const data = {
    name: o.id,
    PointData: apoints,
    type: enumOpType.t_LineItem,
    viewWidth: Math.floor(width),
    viewHeight: Math.floor(height),
    attribute: {
      xPt: Math.floor(o.data.position.x),
      yPt: Math.floor(o.data.position.y),
      width: Math.floor(o.data.end.x - o.data.start.x),
      height: Math.floor(o.data.end.y - o.data.start.y),
      outlineColor: o.data.color,
      outlineWidth: Math.floor(o.data.size),
      rotate: 0, //#选中绘制的外边框矩形的旋转⾓度
      zPt: 0,
    },
  };
  return {
    cmdId: BoardCommond.BoardData,
    data: JSON.stringify(data),
  };
};

// web -> other : redt
const webToOtherRect = (o: any, width: number, height: number) => {
  const apoints = `(${Math.floor(o.data.start.x)},${Math.floor(
    o.data.start.y
  )});(${Math.floor(o.data.end.x)},${Math.floor(o.data.end.y)})`;
  const data = {
    name: o.id,
    PointData: apoints,
    type: enumOpType.t_RectItem,
    viewWidth: Math.floor(width),
    viewHeight: Math.floor(height),
    attribute: {
      xPt: Math.floor(o.data.position.x),
      yPt: Math.floor(o.data.position.y),
      width: Math.floor(o.data.end.x - o.data.start.x),
      height: Math.floor(o.data.end.y - o.data.start.y),
      outlineColor: o.data.color,
      outlineWidth: Math.floor(o.data.size),
      rotate: 0, //#选中绘制的外边框矩形的旋转⾓度
      zPt: 0,
    },
  };
  return {
    cmdId: BoardCommond.BoardData,
    data: JSON.stringify(data),
  };
};

// web -> other : circle
const webToOtherCircle = (o: any, width: number, height: number) => {
  const apoints = `(${Math.floor(o.data.start.x)},${Math.floor(
    o.data.start.y
  )});(${Math.floor(o.data.end.x)},${Math.floor(o.data.end.y)})`;
  const data = {
    name: o.id,
    PointData: apoints,
    type: enumOpType.t_EllipseItem,
    viewWidth: Math.floor(width),
    viewHeight: Math.floor(height),
    attribute: {
      xPt: Math.floor(o.data.position.x),
      yPt: Math.floor(o.data.position.y),
      width: Math.floor(o.data.end.x - o.data.start.x),
      height: Math.floor(o.data.end.y - o.data.start.y),
      outlineColor: o.data.color,
      outlineWidth: Math.floor(o.data.size),
      rotate: 0, //#选中绘制的外边框矩形的旋转⾓度
      zPt: 0,
    },
  };
  return {
    cmdId: BoardCommond.BoardData,
    data: JSON.stringify(data),
  };
};

// web -> other : circle
const webToOtherText = (o: any, width: number, height: number) => {
  const apoints = `(${Math.floor(o.data.position.x)},${Math.floor(
    o.data.position.y
  )})`;
  const data = {
    name: o.id,
    PointData: apoints,
    type: enumOpType.t_TextItem,
    viewWidth: Math.floor(width),
    viewHeight: Math.floor(height),
    text: o.data.text,
    attribute: {
      xPt: Math.floor(o.data.position.x),
      yPt: Math.floor(o.data.position.y),
      width: Math.floor(o.data.position.w),
      height: Math.floor(o.data.position.h),
      outlineColor: "rgb(0,0,0)", //o.data.color,
      outlineWidth: Math.floor(o.data.fontSize),
      rotate: 0, //#选中绘制的外边框矩形的旋转⾓度
      zPt: 0,
    },
  };
  return {
    cmdId: BoardCommond.BoardData,
    data: JSON.stringify(data),
  };
};

///////////////////////////////////////////////////////////
///// other -> web ....  path

const otherToWebText = (o: any, width: number, height: number) => {
  const xs = width / o.viewWidth;
  const ys = height / o.viewHeight;

  const pointss = o.PointData.split(";").map((x: string) => {
    const pps = x.replace(")", "").replace("(", "").split(",");
    return { x: +pps[0] * xs, y: +pps[1] * ys };
  });
  return {
    id: o.name,
    timestamp: +new Date(),
    op: OPERATION_TYPE.TEXT,
    data: {
      pos: [o.attribute.xPt * xs, o.attribute.yPt * ys],
      fontSize: o.attribute.outlineWidth,
      text: o.text,
      position: {
        x: o.attribute.xPt * xs,
        y: o.attribute.yPt * ys,
        w: o.attribute.width * xs,
        h: o.attribute.height * ys,
        center: [
          o.attribute.xPt * xs + (o.attribute.width * xs) / 2,
          o.attribute.yPt * ys + (o.attribute.height * ys) / 2,
        ],
      },
    },
  };
};

const otherToWebPath = (o: any, width: number, height: number) => {
  const xs = width / o.viewWidth;
  const ys = height / o.viewHeight;
  const pointss = o.PointData.split(";").map((x: string) => {
    const pps = x.replace(")", "").replace("(", "").split(",");
    return { x: +pps[0] * xs, y: +pps[1] * ys };
  });
  return {
    id: o.name,
    timestamp: +new Date(),
    op: OPERATION_TYPE.DRAW_LINE,
    data: {
      tool: DrawToolType.Pencil,
      color: o.attribute.outlineColor,
      size: o.attribute.outlineWidth,
      points: pointss,
      position: {
        x: o.attribute.xPt * xs,
        y: o.attribute.yPt * ys,
        w: o.attribute.width * xs,
        h: o.attribute.height * ys,
        center: [
          o.attribute.xPt * xs + (o.attribute.width * xs) / 2,
          o.attribute.yPt * ys + (o.attribute.height * ys) / 2,
        ],
      },
    },
  };
};

const otherToWebLine = (o: any, width: number, height: number) => {
  const xs = width / o.viewWidth;
  const ys = height / o.viewHeight;
  const pointss = o.PointData.split(";").map((x: string) => {
    const pps = x.replace(")", "").replace("(", "").split(",");
    return { x: +pps[0] * xs, y: +pps[1] * ys };
  });
  return {
    id: o.name,
    timestamp: +new Date(),
    op: OPERATION_TYPE.DRAW_LINE,
    data: {
      tool: DrawToolType.Line,
      color: o.attribute.outlineColor,
      size: o.attribute.outlineWidth,
      start: {
        x: o.attribute.xPt * xs,
        y: o.attribute.yPt * ys,
      },
      end: {
        x: o.attribute.xPt * xs + o.attribute.width * xs,
        y: o.attribute.yPt * ys + o.attribute.height * ys,
      },
      position: {
        x: o.attribute.xPt * xs,
        y: o.attribute.yPt * ys,
        w: o.attribute.width * xs,
        h: o.attribute.height * ys,
        center: [
          o.attribute.xPt * xs + (o.attribute.width * xs) / 2,
          o.attribute.yPt * ys + (o.attribute.height * ys) / 2,
        ],
      },
    },
  };
};

const otherToWebRect = (o: any, width: number, height: number) => {
  const xs = width / o.viewWidth;
  const ys = height / o.viewHeight;
  const pointss = o.PointData.split(";").map((x: string) => {
    const pps = x.replace(")", "").replace("(", "").split(",");
    return { x: +pps[0] * xs, y: +pps[1] * ys };
  });
  return {
    id: o.name,
    timestamp: +new Date(),
    op: OPERATION_TYPE.DRAW_SHAPE,
    data: {
      tool: DrawToolType.Rectangle,
      color: o.attribute.outlineColor,
      size: o.attribute.outlineWidth,
      fill: "",
      start: {
        x: o.attribute.xPt * xs,
        y: o.attribute.yPt * ys,
      },
      end: {
        x: o.attribute.xPt * xs + o.attribute.width * xs,
        y: o.attribute.yPt * ys + o.attribute.height * ys,
      },
      position: {
        x: o.attribute.xPt * xs,
        y: o.attribute.yPt * ys,
        w: o.attribute.width * xs,
        h: o.attribute.height * ys,
        center: [
          o.attribute.xPt * xs + (o.attribute.width * xs) / 2,
          o.attribute.yPt * ys + (o.attribute.height * ys) / 2,
        ],
      },
    },
  };
};

const otherToWebEllipse = (o: any, width: number, height: number) => {
  const xs = width / o.viewWidth;
  const ys = height / o.viewHeight;
  const pointss = o.PointData.split(";").map((x: string) => {
    const pps = x.replace(")", "").replace("(", "").split(",");
    return { x: +pps[0] * xs, y: +pps[1] * ys };
  });
  return {
    id: o.name,
    timestamp: +new Date(),
    op: OPERATION_TYPE.DRAW_SHAPE,
    data: {
      tool: DrawToolType.Ellipse,
      color: o.attribute.outlineColor,
      size: o.attribute.outlineWidth,
      fill: "",
      start: {
        x: o.attribute.xPt * xs,
        y: o.attribute.yPt * ys,
      },
      end: {
        x: o.attribute.xPt * xs + o.attribute.width * xs,
        y: o.attribute.yPt * ys + o.attribute.height * ys,
      },
      position: {
        x: o.attribute.xPt * xs,
        y: o.attribute.yPt * ys,
        w: o.attribute.width * xs,
        h: o.attribute.height * ys,
        center: [
          o.attribute.xPt * xs + (o.attribute.width * xs) / 2,
          o.attribute.yPt * ys + (o.attribute.height * ys) / 2,
        ],
      },
    },
  };
};

export const web2Other = (o: any, width: number, height: number) => {
  const op: OPERATION_TYPE = o.op;
  if (op === OPERATION_TYPE.TEXT) return webToOtherText(o, width, height);
  const oType: DrawToolType = o.data.tool as DrawToolType;
  if (oType === DrawToolType.Pencil) {
    return webToOtherPath(o, width, height);
  } else if (oType === DrawToolType.Line) {
    return webToOtherLine(o, width, height);
  } else if (oType === DrawToolType.Rectangle) {
    return webToOtherRect(o, width, height);
  } else {
    return webToOtherCircle(o, width, height);
  }
};

export const other2Web = (o: any, width: number, height: number) => {
  const { type } = o;
  if (type === enumOpType.t_TextItem) {
    return otherToWebText(o, width, height);
  } else if (type === enumOpType.t_PathItem) {
    return otherToWebPath(o, width, height);
  } else if (type === enumOpType.t_LineItem) {
    return otherToWebLine(o, width, height);
  } else if (type === enumOpType.t_RectItem) {
    return otherToWebRect(o, width, height);
  } else {
    return otherToWebEllipse(o, width, height);
  }
};

export const web2OtherArr = (o: Array<any>, width: number, height: number) => {
  return o.map((x) => web2Other(x, width, height));
};

export const other2WebArr = (o: Array<any>, width: number, height: number) => {
  return o.map((x) => other2Web(x, width, height));
};

export const web2Rtc = (o: any, width: number, height: number) => {
  const op: OPERATION_TYPE = o.op;
  const oType: DrawToolType = o && o.data && (o.data.tool as DrawToolType);
  // 清除
  if (op === OPERATION_TYPE.CLEAR_ALL) {
    return { cmdId: BoardCommond.BoardClear };
  }
  // undo
  else if (op === OPERATION_TYPE.UNDO) {
    return {
      cmdId: BoardCommond.BoardData,
      data: JSON.stringify({ name: o.id, type: enumOpType.t_XiangPiCa }),
    };
  } else if (op === OPERATION_TYPE.TEXT)
    return webToOtherText(o, width, height);
  else if (oType === DrawToolType.Pencil) {
    return webToOtherPath(o, width, height);
  } else if (oType === DrawToolType.Line) {
    return webToOtherLine(o, width, height);
  } else if (oType === DrawToolType.Rectangle) {
    return webToOtherRect(o, width, height);
  } else {
    return webToOtherCircle(o, width, height);
  }
};

export const rtc2Web = (o: any, width: number, height: number) => {
  const { type } = o;
  if (type === enumOpType.t_TextItem) {
    return otherToWebText(o, width, height);
  } else if (type === enumOpType.t_PathItem) {
    return otherToWebPath(o, width, height);
  } else if (type === enumOpType.t_LineItem) {
    return otherToWebLine(o, width, height);
  } else if (type === enumOpType.t_RectItem) {
    return otherToWebRect(o, width, height);
  } else {
    return otherToWebEllipse(o, width, height);
  }
};
